/**
 * 文件说明:
 *
 * antd config
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import zh_CN from 'antd/es/locale/zh_CN'

const config = {
    locale: zh_CN,
    virtual: false,
}

export default config
